// STUDIO
export const STUDIO_APP = import.meta.env.VITE_STUDIO_APP;
export const STUDIO_API = import.meta.env.VITE_STUDIO_API;
export const AR_ENABLED = !!import.meta.env.VITE_AR_ENABLED;
export const MIN_IMAGES_FOR_3D = parseInt(
  import.meta.env.VITE_MIN_IMAGES_FOR_3D
);
export const MIN_IMAGES_FOR_SONAR = parseInt(
  import.meta.env.VITE_MIN_IMAGES_FOR_SONAR
);
export const VITE_COATING_BREAKDOWN_WHITELIST =
  import.meta.env.VITE_COATING_BREAKDOWN_WHITELIST?.split(',') || [];

// CONNECT
export const CONNECT_APP = import.meta.env.VITE_CONNECT_APP;

// COMMON
export const CF_API = import.meta.env.VITE_CF_API;

// AZURE
export const AZURE_CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID;
export const AZURE_TENANT = import.meta.env.VITE_AZURE_TENANT;
export const AZURE_POLICY = import.meta.env.VITE_AZURE_POLICY;
export const AZURE_LOGOUT_URI = import.meta.env.VITE_AZURE_LOGOUT_URI;

// SENTRY
export const SENTRY_DSN = import.meta.env.VITE_STUDIO_SENTRY_DSN;
export const SENTRY_ENV = import.meta.env.VITE_SENTRY_ENV;
